module.exports = __webpack_public_path__ + "img/three3Green.763ef50e.jpg";